//--------------- IMPORTAÇÕES ---------------//
import { Overlay, SidebarNoMobile, SidebarMobile} from "./";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function Main() {



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            <Overlay />

            <SidebarNoMobile />

            <SidebarMobile />

        </>
    )
}